import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { InProcessPaymentTransacitons } from "../../../../components/DirectDeposit/Transactions/InProcessPayment";

export interface IInProcessPaymentTransacitonsPage { }

export const InProcessPaymentTransacitonsPage: FC<IInProcessPaymentTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="In Process Payment"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<InProcessPaymentTransacitons />}
		/>
	);
};
